export default "__VITE_ASSET__CuP74pj8__"